export default __webpack_public_path__ + "static/media/iPhone_pickup.983fc9e0.svg";